import {authRequest} from './index.js'


export async function get_subscription(subscription_id){
  let data
  await authRequest.get(
    'subscriptions/' + subscription_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}

export async function get_subscriptions(){
  let data
  await authRequest.get(
    '/subscriptions'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}

export async function create_subscription(subscription){
  let data
  await authRequest.post(
    '/subscriptions',
    { subscription },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}

export async function delete_subscription(subscription_id){
  let data
  await authRequest.delete(
    '/subscriptions/' + subscription_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}

export async function update_subscription(subscription_id, subscription){
  let data
  await authRequest.patch(
    '/subscriptions/' + subscription_id,
    { subscription },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}

export async function activate_child_subscription(child_subscription_id){
  let data
  await authRequest.post(
    `/admin/child_subscriptions/${child_subscription_id}/activate`
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error}
  })
  return data
}